<template>
  <div id="app" class="animated fadeIn">
    <div id="wrapper">
      <main-menu></main-menu>
      <menu-mobile></menu-mobile>
        <div class="padding-if-mobile">
          <transition name="pagina">     
            <router-view/>
          </transition>
        </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import MenuMobile from "@/components/MenuMobile";
require('vue2-animate/dist/vue2-animate.min.css')

export default {
  name: "App",

  components: {
    "main-menu": Menu,
    'menu-mobile': MenuMobile
  },

  data() {
    return {
      toggled: false
    };
  }
};
</script>

<style>
@import url("./assets/fonts/fonts.css");

::-webkit-scrollbar {
    width: 0px;
}

#app {

}

#wrapper {
  padding-left: 370px;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

/* #wrapper.toggled {
} */

#page-content-wrapper {
  width: 100%;
  float: left;
  overflow-x: hidden;
}

.container-fluid {
  padding: 0;
}

.pagina-enter,
.pagina-leave-active {
  opacity: 0;
}

.pagina-enter-active,
.pagina-leave-active {
  transition: opacity 0.1s;
}

@media only screen and (min-width: 320px) and (max-width: 1024px) {

  html, body {
    height: 100%;
  }

  #wrapper {
    padding-left: 0px;
  }

  .padding-if-mobile {
    padding-top: 70px;
  }

}

</style>



// WEBPACK FOOTER //
// src/App.vue